<template>
  <div>
     <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>shopping_cart</md-icon>
          </div>
          <h4 class="title">Cart</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="shoppingCartTable" class="table-shopping">
            <md-table-row class="table-row" slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="">
                <div class="img-container">
                  <img :src="item.image" alt="products"/>
                </div>
              </md-table-cell>
              <md-table-cell md-label="Product" class="td-name">
                <a href="#jacket">{{ item.product }}</a>
                <br/>
                <small>{{ item.category }}</small>
              </md-table-cell>
              <md-table-cell md-label="Color">{{ item.color }}</md-table-cell>
              <md-table-cell md-label="Size">{{ item.size }}</md-table-cell>
             
             
              <md-table-cell>
                <md-button class="md-just-icon md-round md-simple"><md-icon>close</md-icon></md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="table table-stats">
            
            <div class="text-right">
              <md-button class="md-info md-round">
                Download Cart
                <md-icon>keyboard_arrow_right</md-icon>
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: []
    }
  },
  computed: {
    shoppingTotal() {
      return this.shoppingCartTable.reduce((accumulator, current) => {
        return accumulator + current.amount
      }, 0)
    }
  },
  methods: {
    getClass: function(item, id){
      let classes = '';
      switch(item) {
        case 'person': {
          classes = 'md-info'
          break;
        }
        case 'edit': {
          classes = 'md-success'
          break;
        }
        case 'close': {
          classes = 'md-danger'
          break;
        }
      }
      switch(id) {
        case 1:
        case 5: {
          break;
        }
        case 2:
        case 4: {
          classes = `${classes} md-round`
          break;
        }
        case 3: {
          classes = `${classes} md-simple`
          break;
        }
      }
      return classes;
    },
    getAlignClasses: ({ id }) => ({
      'text-right': id
    }),
    increaseQuantity(item) {
      item.qty++;
      this.computeAmount(item);
    },
    decreaseQuantity(item) {
      if (item.qty > 1) {
        item.qty--;
        this.computeAmount(item);
      }
    },
    computeAmount(item) {
      item.amount = item.qty * item.price;
    }
  }
}
</script>
<style lang="scss">
  .text-center {
    text-align: center;
  }

  .places-buttons + div .md-button:not(:last-child) {
    margin-right: 5px;
  }
</style>

<style scoped>
.table-row
{
  height: 180px;
}

</style>
